import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import CommonButton from "../../../../component/Button";
import { StyledFlexColumnView } from "../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";

function IgnitePopup({
  activateDialogOpen,
  handleActivateDialogClose,
  title,
  subTitle,
  buttonName,
  icon,
  children,
  isButtonClick,
  handleButtonClick,
}) {
  const navigate = useNavigate();

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={activateDialogOpen}
      sx={{
        "& .MuiDialog-paper": {
          width: "400px",
          maxWidth: "none",
          borderRadius: "12px",
          background: "#FFF",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        },
      }}
    >
      {/* <img
        src={GreenTick}
        style={{
          position: "absolute",
          width: "max-content",
          opacity: "0.9",
          marginTop: "20px",
          marginLeft: "20px",
        }}
      /> */}

      {/* <DialogActions> */}
      <StyledSpaceBetweenBox>
        <IconButton
          size="small"
          sx={{
            border: "1px solid #D0D5DD",
            borderRadius: "8px",
            padding: "8px",
            marginTop: "10px",
            marginLeft: "20px",
          }}
        >
          {icon}
        </IconButton>
        <Button onClick={handleActivateDialogClose} sx={{ marginTop: "10px" }}>
          <XCloseIco />
        </Button>
      </StyledSpaceBetweenBox>
      {/* </DialogActions> */}

      <DialogContent>
        <Grid2 spacing={2} container>
          <Grid2 size={12}>
            <Typography
              color="#344054"
              fontSize={18}
              fontFamily={"Inter"}
              fontWeight={500}
            >
              {title}
            </Typography>
          </Grid2>

          <Grid2 size={12}>
            <Typography
              color="#667085"
              fontSize={14}
              fontFamily={"Inter"}
              fontWeight={500}
              sx={
                {
                  // whiteSpace: "nowrap",
                  // textOverflow: "ellipsis",
                  // overflow: "hidden",
                }
              }
            >
              {subTitle}
            </Typography>
          </Grid2>

          <Grid2 size={12}>{children}</Grid2>

          <Grid2 size={12}>
            <StyledFlexColumnView style={{ gap: "18px" }}>
              <CommonButton
                variant="contained"
                color="white"
                background="#7F56D9"
                fontWeight="600"
                value={buttonName}
                padding="8px 15px"
                onClick={
                  isButtonClick ? handleButtonClick : handleActivateDialogClose
                }
              />
            </StyledFlexColumnView>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
}

export default IgnitePopup;
